
import { mapGetters } from 'vuex';

export default {
  name: 'TheMainMenuItem',
  props: {
    menuItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('menu', ['selectedMainMenuItem'])
  }
};
